import React from "react";
import {
  Button,
  Col,
  Modal,
  Row,
  Form as BForm,
} from "@themesberg/react-bootstrap";
import { ErrorMessage, Form, Formik } from "formik";
import Toggle from "../../../../components/Toggle/Toggle.jsx";
import { createDriverDetailsSchema } from "../schema.js";
import { transactionDriverHeaders } from "../constants.js";

const AddEditModal = ({ type, data, show, setShow, createUpdate }) => {
  return (
    <>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{type} Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{
              transactionAgentId: data?.transactionAgentId || 0,
              agentName: data?.agentName || "",
              agentNumber: data?.agentNumber || "",
              agentEmail: data?.agentEmail || "",
              description: data?.description || "",
              status: data?.status || false,
            }}
            validationSchema={createDriverDetailsSchema}
            onSubmit={(formValues) => {
              createUpdate(formValues);
            }}
          >
            {({
              values,
              errors,
              handleSubmit,
              handleBlur,
              handleChange,
              setFieldValue,
              isValid,
              dirty,
              initialValues,
            }) => {
              return (
                <Form>
                  {transactionDriverHeaders
                  .filter((h) => h.isShowModal) 
                    .slice(0, transactionDriverHeaders.length - 1)
                    .map((h) => (
                      <Row className="mt-3" key={h.value}>
                        <Col className="d-flex align-items-center">
                          <Col>
                            <BForm.Label>
                              {h.label}
                              {h.required && (
                                <span className="text-danger">*</span>
                              )}
                            </BForm.Label>
                          </Col>

                          <Col xs={9}>
                            {h.label.toLowerCase() === "status" ? (
                              <Toggle
                                checked={values.status}
                                onChange={(e) => {
                                  setFieldValue("status", e.target.checked);
                                }}
                                justify="left"
                              />
                            ) : (
                              <BForm.Control
                                type={
                                  h.inputType === "textarea"
                                    ? "text"
                                    : h.inputType || "text"
                                }
                                name={h.value}
                                placeholder={h.label}
                                value={values[h.value]}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                {...(h.inputType === "textarea" && {
                                  as: "textarea",
                                  rows: 5,
                                  style: {
                                    resize: "vertical",
                                    minHeight: "80px",
                                    maxHeight: "200px",
                                  },
                                })}
                              />
                            )}

                            <ErrorMessage
                              component="div"
                              name={h.value}
                              className="text-danger"
                            />
                          </Col>
                        </Col>
                      </Row>
                    ))}

                  <div className="mt-4 d-flex justify-content-between align-items-center">
                    <Button
                      className="btn-danger"
                      onClick={() => setShow(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn-primary ml-2"
                      disabled={!isValid || !dirty}
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddEditModal;
